import { Component } from '@angular/core';
@Component({
  selector: 'svc-modal-alert-skeleton',
  templateUrl: './svc-modal-alert-skeleton.component.html',
  styleUrls: ['./svc-modal-alert-skeleton.component.scss'],
  host: {
    '[class]': `'block px-4 py-3'`,
  },
})
export class SvcModalAletSkeletonComponent {}
